export default __webpack_public_path__ + "static/media/star_icon.ec7c01ae.png";